import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import GetApp from "@mui/icons-material/GetApp";
import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	> h2 {
		font-weight: bold;
	}
`;

export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const IconExpandMore = styled(GetApp)`
	&&& {
		color: ${({ theme }) => theme.red};
		font-size: 24px;
	}
`;

export const ErrorLogButton = styled(SecondaryButton)`
	background-color: transparent;
	border-color: ${(props) => props.theme.errorDark};
	color: ${(props) => props.theme.errorDark};
	padding: 0.1rem 0.1rem;
	min-width: 135px;
`;

export const ColumnText = styled.div`
	width: 100%;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const ColumnLink = styled.div`
	width: 100%;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #3f5ec9;

	&:hover {
		text-decoration: underline;
		cursor: pointer;
	}
`;
